// extracted by mini-css-extract-plugin
export default {"segmentedControl":"segmented-control-module__segmentedControl--qAOgQ","active":"segmented-control-module__active--fOdti"};